// src/context/AuthContext.js
import React, { createContext, useContext, useMemo, useState } from "react";

const AuthContext = createContext(null);

const SESSION_KEYS = ["token", "user", "areaId", "selected_area", "agencyId", "selected_agency"];

const clearSessionStorage = () => {
  SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
};

function safeJsonParse(value, fallback = null) {
  try {
    if (!value) return fallback;
    if (value === "undefined" || value === "null") return fallback;
    return JSON.parse(value);
  } catch {
    return fallback;
  }
}

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem("token") || "");
  const [user, setUser] = useState(() => safeJsonParse(localStorage.getItem("user"), null));

  const login = (newToken, newUser) => {
    // A login is a new financial session. Never carry agency/area state
    // from the previously authenticated account.
    clearSessionStorage();

    localStorage.setItem("token", newToken);
    if (newUser) localStorage.setItem("user", JSON.stringify(newUser));

    setToken(newToken);
    setUser(newUser || null);
  };

  const logout = () => {
    clearSessionStorage();
    setToken("");
    setUser(null);
  };

  const value = useMemo(
    () => ({
      token,
      user,
      isAuthenticated: Boolean(token),
      login,
      logout,
    }),
    [token, user]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
